import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquare, ExternalLink, Info } from 'lucide-react';
import { telemetryConfig } from '@/lib/telemetry';

const FALLBACK_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSe-carbonpact-feedback/viewform';

export default function Feedback() {
  const formUrl = process.env.REACT_APP_FEEDBACK_FORM_URL || '';
  const hasForm = Boolean(formUrl);
  return (
    <div className="p-6 space-y-6" data-testid="feedback-page">
      <div className="max-w-3xl">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <MessageSquare className="w-7 h-7 text-primary" /> Feedback
        </h1>
        <p className="text-sm text-muted-foreground mt-2">
          Tell us what's working — and what's not. The form is anonymous by default and
          takes about 90 seconds. Your answers shape the next release.
        </p>
      </div>

      {!hasForm && (
        <Card className="max-w-3xl p-4 text-xs flex items-start gap-2 border-amber-500/40 bg-amber-500/5" data-testid="feedback-pending">
          <Info className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
          <span>
            The Google Form URL has not been configured for this environment yet
            (<code className="font-mono">REACT_APP_FEEDBACK_FORM_URL</code>). When the
            launch credentials are filled in, this page will embed the real survey.
          </span>
        </Card>
      )}

      <Card className="max-w-3xl p-0 overflow-hidden" data-testid="feedback-embed-card">
        <iframe
          title="Veridex feedback survey"
          src={hasForm ? formUrl : FALLBACK_URL}
          className="w-full"
          style={{ height: '780px', border: 0 }}
          data-testid="feedback-iframe"
        />
      </Card>

      <div className="max-w-3xl flex items-center gap-3 text-xs text-muted-foreground">
        <span>Form not loading?</span>
        <a
          href={hasForm ? formUrl : FALLBACK_URL}
          target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1 text-primary hover:underline"
          data-testid="feedback-external-link"
        >
          Open in a new tab <ExternalLink className="w-3 h-3" />
        </a>
        <span className="ml-auto font-mono text-[10px] opacity-60">env: {telemetryConfig.env}</span>
      </div>
    </div>
  );
}
